import BrandLogo, { BRAND_NAME, BRAND_TAGLINE } from "./BrandLogo";

export default function BrandHeader({ logoSize = "md", subtitle, showTagline = false, className = "" }) {
  return (
    <div className={`brand-header${className ? ` ${className}` : ""}`}>
      <BrandLogo size={logoSize} />
      <div className="brand-header__text">
        <p className="brand-header__name">{BRAND_NAME}</p>
        {subtitle && <p className="brand-header__sub">{subtitle}</p>}
        {showTagline && <p className="brand-header__tagline">{BRAND_TAGLINE}</p>}
      </div>
    </div>
  );
}
